Jelly.Actions.Set_Input_Value = function(Parameters)
{
	// Sets the value of an input to the specified value
	// Parameters: Namespace, Alias, Value
	var Debug = false && Jelly.Debug.Debug_Mode;
	Debug = false;
	
	if (Debug)
	{
		Jelly.Debug.Group("Set Input Value");
		Jelly.Debug.Log(Parameters);
	}
	
	// Lookup action reference
	var Action_Element = document.getElementById(Parameters["Namespace"]);
	var Action_Reference = Jelly.References.Get_Reference_For_Element(Action_Element);
	
	// Lookup input
	var Input_Element = Action_Reference.Inputs[Parameters["Alias"]]["Element"];
		
	// Verify input value
	if (!Input_Element)
	{	
		Jelly.Debug.Display_Error("No input found to set");
		return;
	}
	
	// Set value
	switch (Input_Element.tagName)
	{	
		// TODO - any conversions, if applicable
		default:
			Input_Element.value = Parameters["Value"];
			break;
	}

	// Followups by type
	var Input_Type;
	if (Action_Reference.Inputs[Parameters.Alias + "_Type"])
		Input_Type = $(Action_Reference.Inputs[Parameters.Alias + "_Type"].Element).val();

	switch (Input_Type) {
		case "Date_Time":
		case "Date":
		case "Time":
			var $Date_Input = $("#" + Input_Element.id.slice(0, "_Value".length * -1) + "_Date_Input");
			console.log($Date_Input);
			if ($Date_Input.length) {
				var Formatted_Date_Value = moment(Parameters.Value).format("l");

				// Set picker view
				var Date_Picker = $Date_Input.pickadate("picker");
				if (Date_Picker)
					Date_Picker.set("select", Formatted_Date_Value, { format: "m/d/yyyy"});

				// Fall back to no picker
				else
					$Date_Input.val(Formatted_Date_Value);
			}

			var $Time_Input = $("#" + Input_Element.id.slice(0, "_Value".length * -1) + "_Time_Input");
			console.log($Time_Input);
			if ($Time_Input.length) {
				var Formatted_Time_Value = moment(Parameters.Value).format("LT");

				// Set picker view
				var Time_Picker = $Time_Input.pickatime("picker");
				if (Time_Picker)
					Time_Picker.set("select", Formatted_Time_Value, { format: "h:i A"});

				// Fall back to no picker
				else
					$Time_Input.val(Formatted_Time_Value);
			}
			break;

		case "Picture":
			// TODO - maybe there's a jelly events way to do this reliably
			var $Uploader = $(Input_Element).closest("[data-kind=\"Iterator\"][data-type=\"Input\"][data-template=\"Default\"]").parent().find("[role=\"uploadcare-uploader\"]");
			uploadcare.SingleWidget($Uploader).value(
				uploadcare.fileFrom('url', Parameters.Value).done(function(Current_File) {
					//console.log($Uploader);
					//console.log(Current_File.cdnUrl);
					//$Uploader.val(Current_File.cdnUrl).change();
				})
			);
			// uploadcare.SingleWidget(Input_Element).value(
			// 	uploadcare.fileFrom('url', Parameters.Value).done(function(Current_File){
			// 			$(Input_Element).val(Current_File.cdnUrl).change();
			// 		}
			// 	)
			// );
			break;
	}

	
	if (Debug)
		Jelly.Debug.Log(Input_Element);
	
	if (Debug)
	{
		Jelly.Debug.End_Group("");
	}
	
	return;
};